

















































































































































































import {
  computed, defineComponent, PropType, ref,
} from '@vue/composition-api'
import { mdiReload, mdiDotsVertical } from '@mdi/js'
import { AggregationResultAttributes, ContextType } from '@/api/v2/types/aggregation-result'
import { useAggregationResultTable, DisplayMode } from '@/views/v2-temp/report/aggregation-container/composables/useAggregationResultTable'
import { isValidDateFormat } from '@/views/v2-temp/common/composables/useDateRange'
import formatNumberOnBlur from '@/directives/formatNumberOnBlur'

export default defineComponent({
  name: 'AggregationResultTable',
  directives: {
    formatNumberOnBlur,
  },
  props: {
    aggregation: {
      type: Object as PropType<AggregationResultAttributes>,
      required: true,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    displayMode: {
      type: String as PropType<DisplayMode>,
      required: true,
    },
    contextId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    contextType: {
      type: String as PropType<ContextType | null>,
      default: null,
    },
    today: {
      type: String,
      default: '',
      validator: (value: string) => isValidDateFormat(value),
    },
    displaySumRow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      aggregationTable,
      isBooleanItem,
      isNumberItem,
      isNew,
      isNotEditable,
      inputType,
      numberText,
      saveResultValue,
      onMenuInput,
      accRow,
    } = useAggregationResultTable(props, emit)

    const table = computed(() => aggregationTable.value(props.contextType, props.contextId))

    const isAllSaved = computed(() => {
      return props.aggregation.contexts.data.every(context => {
        return context.attributes.results.data.every(result => {
          return !!result.attributes.businessRuleResultId
        })
      })
    })

    return {
      isBooleanItem,
      isNumberItem,
      isNotEditable,
      isNew,
      table,
      isAllSaved,
      inputType,
      numberText,
      aggregationTable,
      saveResultValue,
      onMenuInput,
      accRow: computed(() => accRow.value(props.contextType, props.contextId) as Record<string, any>),
      icons: {
        mdiReload,
        mdiDotsVertical,
      },
    }
  },
})
